import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { trackPageView } from "redux/actions";
import AuthRouter from "routes/AuthRouter";

const useRouteAnalytics = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const currentRoute = AuthRouter.find((route) => {
      if (route.path === location.pathname) return true;

      if (route.path.includes(":")) {
        const routePattern = new RegExp("^" + route.path.replace(/:[^\s/]+/g, "([^/]+)") + "$");
        return routePattern.test(location.pathname);
      }

      return false;
    });

    if (currentRoute?.analytics) {
      const { event_type, action_type, ...additionalMetadata } = currentRoute.analytics;

      if (action_type === "view") {
        dispatch(
          trackPageView(event_type, {
            path: location.pathname,
            search: location.search,
            ...additionalMetadata,
          }),
        );
      }
    }
  }, [location.pathname, dispatch]);
};

export default useRouteAnalytics;
